import {useFunnel} from "../context/FunnelContext";
import {getDefaultMeasurementSystem} from "../utils/measurement";

export function useMeasurementSystem() {
    const {state, dispatch} = useFunnel();

    const setMeasurementSystem = (system) => {
        dispatch({
            type: "SET_MEASUREMENT_SYSTEM",
            payload: system,
        });
    };

    const detectSystemFromLocale = () => {
        const detectedSystem = getDefaultMeasurementSystem();
        setMeasurementSystem(detectedSystem);
        return detectedSystem;
    };

    return {
        measurementSystem: state.measurementSystem,
        setMeasurementSystem,
        detectSystemFromLocale,
    };
}
